export const initialState = {
    loading: false,
    sellerClaimsLoading: false,
    priceOfferSaving: false,
};
